export class CacheService {
  static save(key, value) {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        value,
      }),
    );
  }

  static saveWithExpireDate(key, value) {
    sessionStorage.setItem(
      key,
      JSON.stringify({
        value,
      }),
    );
  }

  static get(key) {
    const itemString = sessionStorage.getItem(key);
    if (!itemString) return null;
    const item = JSON.parse(itemString);
    return item.value;
  }

  static remove(key) {
    sessionStorage.removeItem(key);
  }
}
